<template>
  <div class="simulador-aps">
    <div class="simulador-filtros">
      <div>
        <h3>
          <i class="icofont-sliders"></i>
          Selecione as equipes que deseja visualizar:
        </h3>

        <div class="simulador-filtros__buttons">
          <button
            v-for="item in filtrosList"
            :key="item"
            type="button"
            :class="{ active: filtros[item] }"
            @click="toggleFiltro(item)"
          >
            {{ item }}
          </button>
        </div>
      </div>

      <div class="simulador-estrato">
        <label>IED do município</label>

        <div class="simulador-estrato__buttons">
          <button
            v-for="item in [1, 2, 3, 4]"
            :key="item"
            type="button"
            :class="{ active: estrato === item }"
            @click="estrato = item"
          >
            {{ item }}
          </button>
        </div>
      </div>
    </div>

    <div class="simulador-grid">
      <div
        v-for="(card, cardIndex) in cardsSimulador"
        :key="card.key"
        class="simulador-card"
        :class="card.key"
      >
        <div class="simulador-card__top"></div>

        <div class="simulador-card__body">
          <div class="simulador-card__title">
            <!-- <span>Classificação</span> -->
            <h4>{{ card.title }}</h4>
          </div>

          <div
            v-for="metric in card.metrics"
            :key="metric.label"
            class="simulador-metric"
          >
            <div
              class="simulador-metric__header"
              @click="toggleExpand(cardIndex, metric.label)"
            >
              <div>
                <span class="plus">+</span>

                <span class="qtd">
                  {{ quantidadeMetric(cardIndex, metric.label) }}
                </span>

                <strong>
                  {{ getMetricLabel(metric.label) }}
                </strong>
              </div>

              <div>
                <span>=</span>
                <strong>{{ formatCurrency(valorMetric(card, metric)) }}</strong>
              </div>
            </div>

            <div
              v-if="expanded[`${cardIndex}-${metric.label}`]"
              class="simulador-submetrics"
            >
              <div
                v-for="sub in getSubMetricsVisiveis(metric.label)"
                :key="sub.label"
                class="simulador-submetric"
              >
                <div>
                  <span>+</span>

                  <input
                    type="number"
                    min="0"
                    :value="getQuantidade(cardIndex, metric.label, sub.label)"
                    @input="
                      setQuantidade(
                        cardIndex,
                        metric.label,
                        sub.label,
                        $event.target.value
                      )
                    "
                  />
                </div>

                <div class="simulador-submetric__text">
                  <span class="simulador-submetric__label">
                    {{ sub.label }}
                  </span>

                  <small class="simulador-submetric__price">
                    {{
                      formatCurrency(
                        getValorQualidade(metric.label, sub.label, card.key)
                      )
                    }}
                  </small>
                </div>
              </div>
            </div>
          </div>

          <div class="simulador-card__footer">
            <div class="simulador-total">
              <span>=</span>
              <strong>{{ formatCurrency(totalCard(card, cardIndex)) }}</strong>
            </div>

            <div v-if="card.key !== 'otima'" class="simulador-perda">
              <span>vs Ótimo</span>
              <strong
                >- {{ formatCurrency(perdaCard(card, cardIndex)) }}</strong
              >
            </div>

            <div v-else class="simulador-otimo">
              <span>vs Ótimo</span>
              <i class="icofont-trophy"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="simulador-resultado">
      <p>
        O município recebe atualmente
        <strong class="simulador-resultado__valor-atual">
          {{ formatCurrency(totalReceber) }}
        </strong>
        mensais, distribuídos entre os componentes
        <strong>Equidade</strong> ({{ formatCurrency(totalEquidade) }}), Vínculo
        e Acompanhamento Territorial – <strong>CVAT</strong> ({{
          formatCurrency(totalCVAT)
        }}) e <strong>Qualidade</strong> ({{
          formatCurrency(totalQualidade)
        }})<span v-if="resumoEquipesTexto">
          , contemplando {{ resumoEquipesTexto }}</span
        >. Com a melhoria da classificação de todas as equipes para ÓTIMO, o
        repasse mensal pode aumentar em mais
        <strong class="simulador-resultado__valor-ganho">
          {{ formatCurrency(totalPerda) }} </strong
        >.
      </p>
    </div>

    <div class="simulador-resumo-progress">
      <div class="simulador-resumo-progress__row">
        <div class="simulador-resumo-progress__metric is-recebendo">
          <div class="simulador-resumo-progress__content">
            <span class="simulador-resumo-progress__label">Recebendo</span>
            <strong class="simulador-resumo-progress__value">
              {{ formatCurrency(totalReceber) }}
            </strong>
          </div>
        </div>

        <div class="simulador-resumo-progress__metric is-ganho">
          <div class="simulador-resumo-progress__content">
            <span class="simulador-resumo-progress__label"
              >Ganho potencial</span
            >
            <strong class="simulador-resumo-progress__value">
              + {{ formatCurrency(totalPerda) }}
            </strong>
          </div>
        </div>

        <div class="simulador-resumo-progress__metric is-maximo">
          <div class="simulador-resumo-progress__content">
            <span class="simulador-resumo-progress__label"
              >Máximo possível</span
            >
            <strong class="simulador-resumo-progress__value">
              = {{ formatCurrency(totalMaximo) }}
            </strong>
          </div>
        </div>
      </div>

      <div class="simulador-resumo-progress__bar" :title="progressTitle">
        <div class="simulador-resumo-progress__track"></div>
        <div
          class="simulador-resumo-progress__fill"
          :style="{ width: `${progressPercent}%` }"
        ></div>
        <div class="simulador-resumo-progress__caption">
          {{ progressPercent }}% do máximo
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  regras,
  getLabelRegra,
  equityValues,
  metricsSchema,
} from '@/pages/CofinanciamentoSimulacao/utils'

export default {
  name: 'Simulador',
  props: {
    componentes: {
      type: Array,
      default: () => [],
    },

    periodo: {
      type: Object,
      default: null,
    },

    tipoResultado: {
      type: String,
      default: 'previsto',
    },

    totalEquipes: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      filtros: {
        CVAT: true,
        eSF: false,
        eSFR: false,
        eAP: false,
        eSB: false,
        eMulti: false,
        eCR: false,
        eAPP: false,
      },
      estrato: 1,
      expanded: {},
      quantities: {},
      equityValues: { ...equityValues },
      metricsSchema: { ...metricsSchema },
    }
  },
  computed: {
    filtrosList() {
      return ['eSF', 'eSFR', 'eAP', 'eSB', 'eMulti', 'eCR', 'eAPP']
    },

    /**
     * Transforma os componentes filtrados nos cards esperados pelo simulador.
     *
     * Mapeamento:
     * 56 = CVAT
     * 57 = eSF/eAP
     * 58 = eSB
     * 59 = eMulti
     *
     * @returns {Array}
     */
    cardsComponentes() {
      const classificacoes = [
        {
          key: 'regular',
          campo: 'regular',
        },
        {
          key: 'suficiente',
          campo: 'suficiente',
        },
        {
          key: 'boa',
          campo: 'boa',
        },
        {
          key: 'otima',
          campo: 'otima',
        },
      ]

      const componentesPorIndicador = new Map(
        this.componentes.map((componente) => [
          Number(componente.id || componente.indicador),
          componente,
        ])
      )

      const getQuantidade = (indicador, campo) => {
        const componente = componentesPorIndicador.get(Number(indicador))

        return Number(componente?.[campo] || 0)
      }

      const getEquipes = (indicador, campo) => {
        const componente = componentesPorIndicador.get(Number(indicador))

        return Array.isArray(componente?.equipes?.[campo])
          ? componente.equipes[campo]
          : []
      }

      return classificacoes.map((classificacao) => {
        const equipesEsfEap = getEquipes(57, classificacao.campo)

        const quantidadeEap = equipesEsfEap.filter((equipe) => {
          return String(equipe.tp_equipe) === '76'
        }).length

        const quantidadeEsf = equipesEsfEap.filter((equipe) => {
          return String(equipe.tp_equipe) === '70'
        }).length

        return {
          key: classificacao.key,

          metrics: [
            {
              label: 'CVAT',
              value: getQuantidade(56, classificacao.campo),
              isUserEquipe: false,
            },
            {
              label: 'eSF / eAP',
              value: getQuantidade(57, classificacao.campo),
              quantidadeEsf,
              quantidadeEap,
              isUserEquipe: false,
            },
            {
              label: 'eCR',
              value: 0,
              isUserEquipe: false,
            },
            {
              label: 'eAPP',
              value: 0,
              isUserEquipe: false,
            },
            {
              label: 'eSB',
              value: getQuantidade(58, classificacao.campo),
              isUserEquipe: false,
            },
            {
              label: 'eMulti',
              value: getQuantidade(59, classificacao.campo),
              isUserEquipe: false,
            },
          ],
        }
      })
    },

    cardsSimulador() {
      const map = {
        regular: { title: 'Regular', factor: 0.25 },
        suficiente: { title: 'Suficiente', factor: 0.5 },
        boa: { title: 'Bom', factor: 0.75 },
        otima: { title: 'Ótimo', factor: 1 },
      }

      const ordem = ['regular', 'suficiente', 'boa', 'otima']

      return [...this.cardsComponentes]
        .sort((a, b) => {
          return ordem.indexOf(a.key) - ordem.indexOf(b.key)
        })
        .map((card) => {
          const labelsAtivos = ['CVAT']

          if (this.filtros.eSF || this.filtros.eSFR || this.filtros.eAP) {
            labelsAtivos.push('eSF / eAP')
          }

          ;['eSB', 'eMulti', 'eCR', 'eAPP'].forEach((label) => {
            if (this.filtros[label]) {
              labelsAtivos.push(label)
            }
          })

          const metrics = labelsAtivos
            .map((label) => {
              const metricExistente = card.metrics.find((metric) => {
                return metric.label === label
              })

              if (metricExistente) {
                return metricExistente
              }

              return {
                label,
                value: 0,
                isUserEquipe: false,
              }
            })
            .filter((metric) => {
              return this.getSubMetricsVisiveis(metric.label).length > 0
            })

          return {
            ...card,
            title: map[card.key]?.title || card.key,
            metrics,
          }
        })
    },

    totalCVAT() {
      return this.calcularTotais().cvat
    },

    totalQualidade() {
      return this.calcularTotais().qualidade
    },

    totalEquidade() {
      return this.calcularTotais().equidade
    },

    totalPerda() {
      return this.calcularTotais().perda
    },

    totalReceber() {
      return this.totalCVAT + this.totalQualidade + this.totalEquidade
    },

    totalMaximo() {
      return this.totalReceber + this.totalPerda
    },

    /**
     * Calcula o percentual do valor atual em relação ao máximo possível.
     * Usado para preencher a barra de progresso do resumo.
     *
     * @returns {Number}
     */
    progressPercent() {
      const max = Number(this.totalMaximo || 0)
      const atual = Number(this.totalReceber || 0)
      if (max <= 0) return 0
      return Math.max(0, Math.min(100, Math.round((atual / max) * 100)))
    },

    /**
     * Texto auxiliar (tooltip/title) do resumo em barra, exibindo
     * o valor atual e o máximo possível já formatados.
     *
     * @returns {String}
     */
    progressTitle() {
      return `${this.formatCurrency(
        this.totalReceber
      )} de ${this.formatCurrency(this.totalMaximo)}`
    },

    /**
     * Monta o resumo de equipes (ex.: "2 eSF, 3 eAP, 5 eSB...")
     * para ser exibido junto ao texto do simulador.
     *
     * Para equipes compartilhadas entre CVAT e Qualidade (como eSF,
     * eSFR e eAP), considera o maior total entre os componentes,
     * evitando dupla contagem.
     *
     * @returns {String}
     */
    resumoEquipesTexto() {
      const somarTotalPorEquipe = (subLabels, metricLabels = []) => {
        const totaisPorMetrica = metricLabels.map((metricLabel) => {
          return this.cardsSimulador.reduce((total, _card, cardIndex) => {
            const totalSubLabels = subLabels.reduce((sum, subLabel) => {
              const key = this.getQuantidadeKey(
                cardIndex,
                metricLabel,
                subLabel
              )

              return sum + Number(this.quantities?.[key] || 0)
            }, 0)

            return total + totalSubLabels
          }, 0)
        })

        return Math.max(...totaisPorMetrica, 0)
      }

      const partes = []

      const totalESF = somarTotalPorEquipe(['eSF'], ['CVAT', 'eSF / eAP'])
      if (totalESF) partes.push(`${totalESF} eSF`)

      const totalEAP = somarTotalPorEquipe(
        ['eAP 20h', 'eAP 30h'],
        ['CVAT', 'eSF / eAP']
      )
      if (totalEAP) partes.push(`${totalEAP} eAP`)

      const totalESB = somarTotalPorEquipe(
        [
          'eSB I - Comum',
          'eSB I - Quil/Assent',
          'eSB II - Comum',
          'eSB II - Quil/Assent',
        ],
        ['eSB']
      )
      if (totalESB) partes.push(`${totalESB} eSB`)

      const totalEMulti = somarTotalPorEquipe(
        ['Estratégica', 'Complementar', 'Ampliada'],
        ['eMulti']
      )
      if (totalEMulti) partes.push(`${totalEMulti} eMulti`)

      const totalESFR = somarTotalPorEquipe(['eSFR'], ['CVAT', 'eSF / eAP'])
      if (totalESFR) partes.push(`${totalESFR} eSFR`)

      const totalECR = somarTotalPorEquipe(
        ['eCR I', 'eCR II', 'eCR III'],
        ['eCR']
      )
      if (totalECR) partes.push(`${totalECR} eCR`)

      const totalEAPP = somarTotalPorEquipe(
        ['Essencial 20h', 'Essencial 30h', 'Ampliada 20h', 'Ampliada 30h'],
        ['eAPP']
      )
      if (totalEAPP) partes.push(`${totalEAPP} eAPP`)

      return partes.join(', ')
    },
  },
  mounted() {},
  watch: {
    componentes: {
      deep: true,
      immediate: true,
      handler() {
        this.reiniciarSimulador()
      },
    },

    periodo() {
      this.reiniciarSimulador()
    },

    tipoResultado() {
      this.reiniciarSimulador()
    },
  },
  methods: {
    /**
     * Reinicia as quantidades do simulador sempre que o período,
     * o tipo de resultado ou os componentes forem alterados.
     *
     * @return {void}
     */
    reiniciarSimulador() {
      this.expanded = {}
      this.quantities = {}

      this.$nextTick(() => {
        this.preencherFiltrosIniciais()
        this.preencherQuantidadesIniciais()
      })
    },

    /**
     * Ativa apenas os filtros que possuem equipes nos cards.
     * Os demais permanecem visíveis, porém inativos.
     *
     * @returns {void}
     */
    preencherFiltrosIniciais() {
      const ativos = {}

      this.cardsComponentes.forEach((card) => {
        card.metrics.forEach((metric) => {
          if (Number(metric.value || 0) <= 0) {
            return
          }

          if (metric.label === 'eSF / eAP') {
            if (Number(metric.quantidadeEsf || 0) > 0) {
              ativos.eSF = true
            }

            if (Number(metric.quantidadeEap || 0) > 0) {
              ativos.eAP = true
            }

            return
          }

          ativos[metric.label] = true
        })
      })

      Object.keys(this.filtros).forEach((key) => {
        if (key === 'CVAT') {
          this.$set(this.filtros, key, true)
          return
        }

        this.$set(this.filtros, key, Boolean(ativos[key]))
      })
    },

    /**
     * Preenche as quantidades iniciais do simulador
     * com base nos cards recebidos do modal.
     *
     * @returns {void}
     */
    preencherQuantidadesIniciais() {
      this.cardsSimulador.forEach((card, cardIndex) => {
        card.metrics.forEach((metric) => {
          if (metric.label === 'eSF / eAP') {
            if (this.filtros.eSF && Number(metric.quantidadeEsf || 0) > 0) {
              const keyEsf = this.getQuantidadeKey(
                cardIndex,
                metric.label,
                'eSF'
              )

              if (this.quantities[keyEsf] === undefined) {
                this.$set(
                  this.quantities,
                  keyEsf,
                  Number(metric.quantidadeEsf || 0)
                )
              }
            }

            if (this.filtros.eAP && Number(metric.quantidadeEap || 0) > 0) {
              const keyEap = this.getQuantidadeKey(
                cardIndex,
                metric.label,
                'eAP 20h'
              )

              if (this.quantities[keyEap] === undefined) {
                this.$set(
                  this.quantities,
                  keyEap,
                  Number(metric.quantidadeEap || 0)
                )
              }
            }

            return
          }

          const subMetrics = this.getSubMetricsVisiveis(metric.label)

          if (!subMetrics.length) {
            return
          }

          const primeiraSubMetric = subMetrics[0]

          const key = this.getQuantidadeKey(
            cardIndex,
            metric.label,
            primeiraSubMetric.label
          )

          if (this.quantities[key] === undefined) {
            this.$set(this.quantities, key, Number(metric.value || 0))
          }
        })
      })
    },

    /**
     * Alterna a exibição dos detalhes da métrica.
     *
     * @param {Number} cardIndex
     * @param {String} metricLabel
     * @returns {void}
     */
    toggleExpand(cardIndex, metricLabel) {
      const key = `${cardIndex}-${metricLabel}`
      const isAbrindo = !this.expanded[key]

      if (isAbrindo) {
        Object.keys(this.expanded).forEach((k) => {
          if (this.expanded[k]) {
            this.$set(this.expanded, k, false)
          }
        })
      }

      this.$set(this.expanded, key, isAbrindo)
    },

    /**
     * Ativa ou desativa um filtro.
     * Ao ativar, garante que as quantidades iniciais sejam criadas.
     *
     * @param {String} filtro
     * @returns {void}
     */
    toggleFiltro(filtro) {
      this.$set(this.filtros, filtro, !this.filtros[filtro])

      this.$nextTick(() => {
        this.preencherQuantidadesIniciais()
      })
    },

    /**
     * Retorna as submétricas de uma métrica.
     *
     * @param {String} metricLabel
     * @returns {Array}
     */
    getSubMetrics(metricLabel) {
      return this.metricsSchema[metricLabel] || []
    },

    /**
     * Retorna as submétricas visíveis conforme os filtros ativos.
     *
     * @param {String} metricLabel
     * @returns {Array}
     */
    getSubMetricsVisiveis(metricLabel) {
      return this.getSubMetrics(metricLabel).filter((sub) => {
        if (sub.label === 'eSF' && !this.filtros.eSF) return false
        if (sub.label === 'eSFR' && !this.filtros.eSFR) return false
        if (sub.label.includes('eAP') && !this.filtros.eAP) return false
        if (sub.label.includes('eSB') && !this.filtros.eSB) return false
        if (sub.label.includes('eCR') && !this.filtros.eCR) return false

        if (
          ['Estratégica', 'Complementar', 'Ampliada'].includes(sub.label) &&
          !this.filtros.eMulti
        ) {
          return false
        }

        if (
          [
            'Essencial 20h',
            'Essencial 30h',
            'Ampliada 20h',
            'Ampliada 30h',
          ].includes(sub.label) &&
          !this.filtros.eAPP
        ) {
          return false
        }

        return true
      })
    },

    /**
     * Monta a chave usada para armazenar a quantidade.
     *
     * @param {Number} cardIndex
     * @param {String} metricLabel
     * @param {String} subLabel
     * @returns {String}
     */
    getQuantidadeKey(cardIndex, metricLabel, subLabel) {
      return `${cardIndex}-${metricLabel}-${subLabel}`
    },

    /**
     * Retorna a quantidade de uma submétrica.
     *
     * @param {Number} cardIndex
     * @param {String} metricLabel
     * @param {String} subLabel
     * @returns {Number}
     */
    getQuantidade(cardIndex, metricLabel, subLabel) {
      const key = this.getQuantidadeKey(cardIndex, metricLabel, subLabel)
      const value = this.quantities[key]

      // Mantém vazio quando o usuário apaga o campo
      // mas exibe 0 quando o valor é zero ou inexistente
      if (value === '') {
        return ''
      }

      if (value === undefined) {
        return 0
      }

      return value
    },

    /**
     * Retorna o valor da equipe conforme classificação usando as regras.
     *
     * @param {String} metricLabel
     * @param {String} subLabel
     * @param {String} cardKey
     * @returns {Number}
     */
    getValorQualidade(metricLabel, subLabel, cardKey) {
      const classificacoes = {
        regular: 'Regular',
        suficiente: 'Suficiente',
        boa: 'Bom',
        otima: 'Ótimo',
      }

      const tipoClassificacao = classificacoes[cardKey]

      const listaRegras =
        metricLabel === 'CVAT'
          ? regras.vinculo_e_acompanhamento
          : regras.qualidade

      const regra = listaRegras.find((item) => {
        return item.label === getLabelRegra(subLabel)
      })

      if (!regra) {
        return 0
      }

      const classificacao = regra.classificacao.find((item) => {
        return item.tipo === tipoClassificacao
      })

      return Number(classificacao?.valor || 0)
    },

    /**
     * Retorna a quantidade total preenchida em uma métrica.
     *
     * @param {Number} cardIndex
     * @param {String} metricLabel
     * @returns {Number}
     */
    quantidadeMetric(cardIndex, metricLabel) {
      return this.getSubMetricsVisiveis(metricLabel).reduce((total, sub) => {
        return (
          total +
          Number(this.getQuantidade(cardIndex, metricLabel, sub.label) || 0)
        )
      }, 0)
    },

    /**
     * Define a quantidade de uma submétrica.
     *
     * @param {Number} cardIndex
     * @param {String} metricLabel
     * @param {String} subLabel
     * @param {String|Number} value
     * @returns {void}
     */
    setQuantidade(cardIndex, metricLabel, subLabel, value) {
      const key = this.getQuantidadeKey(cardIndex, metricLabel, subLabel)
      const quantidade = value === '' ? '' : Math.max(0, Number(value || 0))

      this.$set(this.quantities, key, quantidade)
    },

    /**
     * Calcula o valor de uma métrica.
     *
     * @param {Object} card
     * @param {Object} metric
     * @returns {Number}
     */
    valorMetric(card, metric) {
      const cardIndex = this.cardsSimulador.findIndex((item) => {
        return item.key === card.key
      })

      return this.getSubMetricsVisiveis(metric.label).reduce((total, sub) => {
        const quantidade = Number(
          this.getQuantidade(cardIndex, metric.label, sub.label) || 0
        )

        const valor = this.getValorQualidade(metric.label, sub.label, card.key)

        return total + quantidade * valor
      }, 0)
    },

    /**
     * Calcula o total de um card.
     *
     * @param {Object} card
     * @param {Number} cardIndex
     * @returns {Number}
     */
    totalCard(card, cardIndex) {
      return card.metrics.reduce((total, metric) => {
        return (
          total +
          this.getSubMetricsVisiveis(metric.label).reduce((subtotal, sub) => {
            const quantidade = Number(
              this.getQuantidade(cardIndex, metric.label, sub.label) || 0
            )

            const valor = this.getValorQualidade(
              metric.label,
              sub.label,
              card.key
            )

            return subtotal + quantidade * valor
          }, 0)
        )
      }, 0)
    },

    /**
     * Calcula a perda do card em relação ao ótimo.
     *
     * @param {Object} card
     * @param {Number} cardIndex
     * @returns {Number}
     */
    perdaCard(card, cardIndex) {
      if (card.key === 'otima') {
        return 0
      }

      return card.metrics.reduce((total, metric) => {
        return (
          total +
          this.getSubMetricsVisiveis(metric.label).reduce((subtotal, sub) => {
            const quantidade = Number(
              this.getQuantidade(cardIndex, metric.label, sub.label) || 0
            )

            const valorAtual = this.getValorQualidade(
              metric.label,
              sub.label,
              card.key
            )

            const valorOtimo = this.getValorQualidade(
              metric.label,
              sub.label,
              'otima'
            )

            return subtotal + quantidade * (valorOtimo - valorAtual)
          }, 0)
        )
      }, 0)
    },

    /**
     * Soma o total por métrica e retorna o maior total encontrado.
     *
     * Usado para evitar duplicidade entre componentes que representam
     * as mesmas equipes, como CVAT e Qualidade para eSF, eSFR e eAP.
     *
     * @param {Array} subLabels
     * @param {Array} metricLabels
     * @returns {Number}
     */
    somarTotalPorEquipe(subLabels, metricLabels = []) {
      const totaisPorMetrica = metricLabels.map((metricLabel) => {
        return this.cardsSimulador.reduce((total, _card, cardIndex) => {
          const totalSubLabels = subLabels.reduce((sum, subLabel) => {
            const key = this.getQuantidadeKey(cardIndex, metricLabel, subLabel)

            return sum + Number(this.quantities?.[key] || 0)
          }, 0)

          return total + totalSubLabels
        }, 0)
      })

      return Math.max(...totaisPorMetrica, 0)
    },

    /**
     * Calcula o valor total da Equidade.
     *
     * Para eSF, eSFR e eAP, considera apenas a quantidade única
     * de equipes, utilizando o maior total entre CVAT e Qualidade.
     *
     * @returns {number}
     */
    calcularEquidade() {
      const valorESF = this.equityValues.eSF[this.estrato - 1]
      const valorEAP30h = this.equityValues.eAP30h[this.estrato - 1]
      const valorEAP20h = this.equityValues.eAP20h[this.estrato - 1]

      const totalESF = this.somarTotalPorEquipe(['eSF'], ['CVAT', 'eSF / eAP'])
      const totalEAP30h = this.somarTotalPorEquipe(
        ['eAP 30h'],
        ['CVAT', 'eSF / eAP']
      )
      const totalEAP20h = this.somarTotalPorEquipe(
        ['eAP 20h'],
        ['CVAT', 'eSF / eAP']
      )

      return (
        totalESF * valorESF +
        totalEAP30h * valorEAP30h +
        totalEAP20h * valorEAP20h
      )
    },

    /**
     * Calcula os totais gerais do simulador.
     *
     * @returns {Object}
     */
    calcularTotais() {
      let cvat = 0
      let qualidade = 0
      let equidade = 0
      let perda = 0

      this.cardsSimulador.forEach((card, cardIndex) => {
        card.metrics.forEach((metric) => {
          this.getSubMetricsVisiveis(metric.label).forEach((sub) => {
            const quantidade = Number(
              this.getQuantidade(cardIndex, metric.label, sub.label) || 0
            )

            const valorAtual =
              quantidade *
              this.getValorQualidade(metric.label, sub.label, card.key)

            const valorMaximo =
              quantidade *
              this.getValorQualidade(metric.label, sub.label, 'otima')

            if (metric.label === 'CVAT') {
              cvat += valorAtual
            } else {
              qualidade += valorAtual
            }

            if (card.key !== 'otima') {
              perda += valorMaximo - valorAtual
            }
          })
        })
      })

      equidade = this.calcularEquidade()

      return { cvat, qualidade, equidade, perda }
    },

    /**
     * Formata valores em moeda brasileira.
     *
     * @param {Number} value
     * @returns {String}
     */
    formatCurrency(value) {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }).format(Number(value || 0))
    },

    /**
     * Retorna o título exibido para a métrica.
     *
     * @param {String} metricLabel
     * @returns {String}
     */
    getMetricLabel(metricLabel) {
      if (metricLabel === 'eSF / eAP') {
        return this.filtros.eAP ? 'eSF / eAP' : 'eSF'
      }

      return metricLabel
    },
  },
}
</script>

<style lang="scss">
.simulador-aps {
  padding: 24px 0;
  border-radius: 24px;
}

.simulador-filtros {
  background: #fff;
  border-radius: 24px;
  padding: 24px;
  margin-bottom: 28px;
  display: flex;
  justify-content: space-between;
  gap: 24px;
  border: 1px solid #e2e8f0;
}

.simulador-filtros h3 {
  font-size: 18px;
  font-weight: 900;
  color: #0f172a;
  margin: 0 0 14px;
}

.simulador-filtros__buttons,
.simulador-estrato__buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.simulador-filtros button,
.simulador-estrato button {
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  color: #94a3b8;
  border-radius: 12px;
  padding: 8px 14px;
  font-size: 12px;
  font-weight: 900;
}

.simulador-filtros button.active,
.simulador-estrato button.active {
  background: #3f84b6;
  border-color: #3f84b6;
  color: #fff;
}

.simulador-estrato {
  min-width: 260px;
  background: #f8fafc;
  border-radius: 18px;
  padding: 16px;
}

.simulador-estrato label {
  display: block;
  font-size: 13px;
  font-weight: 900;
  color: #64748b;
  margin-bottom: 10px;
}

.simulador-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 24px;
}

.simulador-card {
  background: #fff;
  border-radius: 24px;
  overflow: hidden;
  border: 1px solid #f1f5f9;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.08);
}

.simulador-card__top {
  height: 12px;
}

.simulador-card.regular .simulador-card__top {
  background: #ce7000;
}

.simulador-card.suficiente .simulador-card__top {
  background: #d1a100;
}

.simulador-card.boa .simulador-card__top {
  background: #00a972;
}

.simulador-card.otima .simulador-card__top {
  background: #3f84b6;
}

.simulador-card__body {
  padding: 22px;
}

.simulador-card__title {
  text-align: center;
  margin-bottom: 20px;
}

.simulador-card__title span {
  font-size: 10px;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 2px;
  color: #94a3b8;
}

.simulador-card__title h4 {
  margin: 4px 0 0;
  font-size: 24px;
  font-weight: 900;
}

.simulador-metric {
  border-bottom: 1px solid #f1f5f9;
  padding: 10px 0;
}

.simulador-metric__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}

.simulador-metric__header > div {
  display: flex;
  align-items: center;
  gap: 10px;
}

.plus {
  color: #cbd5e1;
  font-weight: 900;
  font-size: 18px;
}

.qtd {
  width: 48px;
  height: 32px;
  border-radius: 10px;
  background: #eff6ff;
  color: #3f84b6;
  border: 1px solid #dbeafe;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 900;
}

.simulador-submetrics {
  margin-top: 12px;
  margin-left: 22px;
  padding-left: 14px;
  border-left: 2px solid #e2e8f0;
}

.simulador-submetric {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: center;
  column-gap: 10px;
  margin-bottom: 12px;
  padding: 4px 0;
}

.simulador-submetric > div:first-child {
  display: grid;
  grid-template-columns: 14px 44px;
  align-items: center;
  gap: 10px;
}

.simulador-submetric__text {
  display: flex !important;
  flex-direction: column;
  min-width: 0;
  line-height: 1.2;
}

.simulador-submetric__label {
  font-size: 12px;
  font-weight: 800;
  color: #64748b;
  white-space: nowrap;
}

.simulador-submetric__price {
  font-size: 11px;
  font-weight: 900;
  color: #94a3b8;
  margin-top: 2px;
  white-space: nowrap;
}

.simulador-submetric input {
  width: 44px;
  height: 28px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  border-radius: 7px;
  padding: 4px;
  text-align: center;
  font-size: 11px;
  font-weight: 900;
  color: #64748b;
}

.simulador-card__footer {
  margin-top: 22px;
  padding-top: 16px;
  border-top: 2px dashed #f1f5f9;
}

.simulador-total,
.simulador-perda,
.simulador-otimo {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 16px;
  padding: 14px;
  margin-top: 10px;
  font-weight: 900;
}

.simulador-total {
  background: #f8fafc;
}

.simulador-perda {
  background: #fef2f2;
  color: #dc2626;
}

.simulador-otimo {
  background: #f0fdf4;
  color: #15803d;
}

.simulador-resultado {
  margin-top: 28px;
  background: #fff;
  border-left: 8px solid #3f84b6;
  border-radius: 28px;
  padding: 28px;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.06);
}

.simulador-resultado p {
  margin: 0;
  font-size: 18px;
  color: #334155;
  line-height: 1.6;
}

.simulador-resultado__valor-atual {
  color: #16a34a;
}

.simulador-resultado__valor-ganho {
  color: #f59e0b;
}

.simulador-resumo-progress {
  margin-top: 22px;
  background: rgba(255, 255, 255, 0.72);
  border: 1px solid #f1f5f9;
  border-radius: 24px;
  padding: 16px 18px 18px;
}

.simulador-resumo-progress__row {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 18px;
  align-items: start;
}

.simulador-resumo-progress__metric {
  display: flex;
  align-items: center;
  min-width: 0;
}

.simulador-resumo-progress__content {
  display: flex;
  flex-direction: column;
  gap: 7px;
  min-width: 0;
}

.simulador-resumo-progress__label {
  display: block;
  font-size: 12px;
  font-weight: 900;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.simulador-resumo-progress__value {
  font-size: 28px;
  font-weight: 900;
  margin: 0;
  line-height: 1.1;
}

.simulador-resumo-progress__metric.is-recebendo
  .simulador-resumo-progress__value {
  color: #16a34a;
}

.simulador-resumo-progress__metric.is-ganho .simulador-resumo-progress__value {
  color: #f59e0b;
}

.simulador-resumo-progress__metric.is-maximo .simulador-resumo-progress__value {
  color: #354abb;
}

.simulador-resumo-progress__bar {
  position: relative;
  margin-top: 14px;
  padding-top: 12px;
}

.simulador-resumo-progress__track {
  height: 10px;
  background: #e2e8f0;
  border-radius: 999px;
  overflow: hidden;
}

.simulador-resumo-progress__fill {
  position: absolute;
  left: 0;
  top: 12px;
  height: 10px;
  background: linear-gradient(90deg, #16a34a 0%, #f59e0b 55%, #354abb 100%);
  border-radius: 999px;
  transition: width 180ms ease;
}

.simulador-resumo-progress__caption {
  margin-top: 10px;
  font-size: 12px;
  font-weight: 900;
  color: #64748b;
  text-align: right;
}

@media (max-width: 768px) {
  .simulador-filtros {
    flex-direction: column;
  }

  .simulador-resumo-progress__row {
    grid-template-columns: 1fr;
  }
}

@media print {
  .simulador-aps {
    .simulador-filtros,
    .simulador-grid {
      display: none !important;
    }

    .simulador-resultado {
      margin-top: 28px;
      background: #fff;
      border-left: 8px solid #3f84b6;
      border-radius: 28px;
      padding: 28px;
      box-shadow: 0 10px 30px rgba(15, 23, 42, 0.06);
    }

    .simulador-resultado p {
      margin: 0;
      font-size: 18px;
      color: #334155;
      line-height: 1.6;
    }

    .simulador-resultado__valor-atual {
      color: #16a34a;
    }

    .simulador-resultado__valor-ganho {
      color: #f59e0b;
    }

    .simulador-resumo-progress {
      margin-top: 22px;
      background: rgba(255, 255, 255, 0.72);
      border: 1px solid #f1f5f9;
      border-radius: 24px;
      padding: 16px 18px 18px;
    }

    .simulador-resumo-progress__row {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      gap: 18px;
      align-items: start;
    }

    .simulador-resumo-progress__metric {
      display: flex;
      align-items: center;
      min-width: 0;
    }

    .simulador-resumo-progress__content {
      display: flex;
      flex-direction: column;
      gap: 7px;
      min-width: 0;
    }

    .simulador-resumo-progress__label {
      display: block;
      font-size: 12px;
      font-weight: 900;
      color: #94a3b8;
      text-transform: uppercase;
      letter-spacing: 0.6px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .simulador-resumo-progress__value {
      font-size: 28px;
      font-weight: 900;
      margin: 0;
      line-height: 1.1;
    }

    .simulador-resumo-progress__metric.is-recebendo
      .simulador-resumo-progress__value {
      color: #16a34a;
    }

    .simulador-resumo-progress__metric.is-ganho
      .simulador-resumo-progress__value {
      color: #f59e0b;
    }

    .simulador-resumo-progress__metric.is-maximo
      .simulador-resumo-progress__value {
      color: #354abb;
    }

    .simulador-resumo-progress__bar {
      position: relative;
      margin-top: 14px;
      padding-top: 12px;
    }

    .simulador-resumo-progress__track {
      height: 10px;
      background: #e2e8f0;
      border-radius: 999px;
      overflow: hidden;
    }

    .simulador-resumo-progress__fill {
      position: absolute;
      left: 0;
      top: 12px;
      height: 10px;
      background: linear-gradient(90deg, #16a34a 0%, #f59e0b 55%, #354abb 100%);
      border-radius: 999px;
      transition: width 180ms ease;
    }

    .simulador-resumo-progress__caption {
      margin-top: 10px;
      font-size: 12px;
      font-weight: 900;
      color: #64748b;
      text-align: right;
    }
  }
}
</style>
